export enum UpsellFormId {
  InProductEMRUnlock = 'iOdnF27x',
  EmailEMRUnlock = 'R9HcsY24',
  EmailMarketingCredit = 'lOwe1P80',
}
